import { defineMessages } from 'react-intl';

import { FiatCurrency } from '#src/__generated__/globalTypes.ts';
import { useIntlContext } from '#src/contexts/intl/index.ts';

const currencyMessages = defineMessages({
  [FiatCurrency.EUR]: {
    defaultMessage: 'Euro (EUR)',
  },
  [FiatCurrency.GBP]: {
    defaultMessage: 'Pound sterling (GBP)',
  },
  [FiatCurrency.USD]: {
    defaultMessage: 'United States dollar (USD)',
  },
});

export const useCurrencyOptions = () => {
  const { formatMessage } = useIntlContext();
  const currencies = Object.values(FiatCurrency).map(c => ({
    label: formatMessage(currencyMessages[c]),
    value: c,
  }));
  return currencies;
};
